import { Link } from 'react-router-dom';
import { Helmet } from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function NotFound() {
  return (
    <>
      <Helmet
        title="404 - 页面未找到 - 韩漫之家"
        description="抱歉，您访问的页面不存在。返回韩漫之家首页，继续阅读最新高清免费韩国漫画。"
        canonicalUrl="https://www.hanmanzhijia.com/404"
      />
      <main className="min-h-screen bg-background-50">
        <Navbar />
        <div className="flex flex-col items-center justify-center min-h-[70vh] px-4 text-center pt-16">
          <div className="w-24 h-24 flex items-center justify-center rounded-full bg-background-200 text-foreground-400 mb-6">
            <i className="ri-emotion-sad-line text-4xl"></i>
          </div>
          <h1 className="text-4xl md:text-6xl font-heading font-bold text-foreground-950 mb-3">404</h1>
          <p className="text-lg text-foreground-600 mb-2">页面未找到</p>
          <p className="text-sm text-foreground-500 mb-8 max-w-md">
            抱歉，您访问的页面不存在或已被移除。请检查网址是否正确，或返回首页继续浏览。
          </p>
          <Link
            to="/"
            className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            返回首页
          </Link>
        </div>
        <Footer />
      </main>
    </>
  );
}